import React, { FC } from 'react';

const FoodoraWallet: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.342 163.773H66.009C49.6523 163.773 36.3486 150.457 36.3486 134.085V65.6881C36.3486 49.3161 49.6523 36 66.009 36H134.342C150.699 36 164.003 49.3161 164.003 65.6881V134.085C164.003 150.457 150.699 163.773 134.342 163.773Z"
        fill="#FAF9F6"
      />
      <path
        d="M136.997 67.7359C144.489 67.7359 150.878 72.4512 153.375 79.0777C153.181 68.492 144.389 59.9385 133.593 59.9385H70.9932C70.4634 59.9385 65.2017 59.9647 64.6824 60.0067H53.4666C49.4378 60.0067 46.1748 63.2727 46.1748 67.3054V67.7412H136.997V67.7359Z"
        fill="#242424"
      />
      <path
        d="M135.429 144.981H63.1241C53.7339 144.981 46.1221 137.362 46.1221 127.963V70.3928H135.429C144.819 70.3928 152.431 78.0117 152.431 87.4107V127.963C152.431 137.362 144.819 144.981 135.429 144.981Z"
        fill="#DF1067"
      />
      <path
        d="M154.492 114.153C154.492 115.524 153.38 116.637 152.011 116.637H120.215C113.658 116.637 108.344 111.412 108.344 104.964C108.344 98.5163 113.658 93.2917 120.215 93.2917H152.011C153.38 93.2917 154.492 94.4049 154.492 95.7753V114.153Z"
        fill="#0A4342"
      />
      <path
        d="M114.214 104.77C114.214 101.661 116.732 99.1411 119.837 99.1411C122.943 99.1411 125.461 101.661 125.461 104.77C125.461 107.878 122.943 110.399 119.837 110.399C116.732 110.399 114.214 107.878 114.214 104.77Z"
        fill="white"
      />
      <path
        d="M129.202 153.534C129.202 142.66 138.01 133.844 148.874 133.844C159.739 133.844 168.547 142.66 168.547 153.534C168.547 164.409 159.739 173.225 148.874 173.225C138.01 173.225 129.202 164.414 129.202 153.534Z"
        fill="#0A4342"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.293 153.419C137.293 152.277 138.218 151.351 139.359 151.351H157.94C159.08 151.351 160.005 152.277 160.005 153.419C160.005 154.561 159.08 155.487 157.94 155.487H139.359C138.218 155.487 137.293 154.561 137.293 153.419Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M148.649 142.294C149.789 142.294 150.714 143.219 150.714 144.361V162.96C150.714 164.101 149.789 165.027 148.649 165.027C147.508 165.027 146.583 164.101 146.583 162.96V144.361C146.583 143.219 147.508 142.294 148.649 142.294Z"
        fill="white"
      />
    </svg>
  );
};

export default FoodoraWallet;
